
const municipalityInfo = '北京,上海,天津,重庆';  // 直辖市集合

const isMunicipality = (province) => municipalityInfo.indexOf(province) > -1;

const formatAddress = (newVal, strict) => {
	let {province, city, district, isDistrictDicEmpty} = newVal;
	if ((!province || (!district && !isDistrictDicEmpty)) && !strict) return;
	province = province || '';
	city = city || '';
	district = district || '';
	let exportProvince, exportCity, exportDistrict, area;
	if (province && isMunicipality(province)) {
		exportCity = province;
		area = `${province}市 ${district}`
	} else {
		if (province === '海南' && isDistrictDicEmpty) {
			area = `${province}省 ${city}`;
			const lastStr = city.substr(-1);
			if (lastStr !== '县') {area += '市'}
		} else {
			const lastThreeStr = city.substr(-3);
			if (lastThreeStr === '自治州') {
				area = `${province}省 ${city} ${district}`;
			} else {
				area = `${province}省 ${city}市 ${district}`;
			}
		}
		exportCity = city || ''
	}
	exportProvince = province || '';
	exportDistrict = district || '';
	let completedAddress = '';
	if (newVal.address) {
		completedAddress = area + ' ' + newVal.address
	}
	return {
		exportProvince,
		exportCity,
		exportDistrict,
		area,
		completedAddress
	}
};


export {
	isMunicipality,
	formatAddress,
}
